export default __webpack_public_path__ + "static/media/PM Moorthy.0b945168.jpg";